import CertsSidePanelBodyHistory from './CertsSidePanelBodyHistory';

export default CertsSidePanelBodyHistory;
